var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"text-center",style:({ height: '20vh', position: 'relative' })},[_c('b-col',{style:({ position: 'absolute', bottom: '0px' })},[_c('b-spinner',{attrs:{"label":"Loading..."}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }